import React, { useState, useEffect } from 'react';
import { Galleria } from 'primereact/galleria';
// import { PhotoService } from './service/PhotoService';

export default function ImageGallery({imageList}) {
    const [images, setImages] = useState(imageList);
    const responsiveOptions = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '575px',
            numVisible: 2
        }
    ];

    // useEffect(() => {
    //     PhotoService.getImages().then(data => setImages(data));
    // }, []);

    const itemTemplate = (item) => {
        return <img src={item.itemImageSrc} alt={item.alt} style={{ maxWidth: '100%', display: 'block',maxHeight:"500px" }} />;
    }

    const thumbnailTemplate = (item) => {
        return <img src={item.thumbnailImageSrc} alt={item.alt} style={{ display: 'block' }} height="80px"/>;
    }

    const caption = (item) => {
        return (
            <React.Fragment>
                <div className="text-xl mb-2 font-bold">{item.title}</div>
                <p className="text-white">{item.alt}</p>
            </React.Fragment>
        );
    }

    return (
        <div className="card" >
            <Galleria value={images} responsiveOptions={responsiveOptions} numVisible={3} 
                item={itemTemplate} thumbnail={thumbnailTemplate}  style={{ maxWidth: '640px' }} />
        </div>
    )
}
        